import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IGetUsersResponse } from '../interfaces/get-users-response.interface';
import { Observable } from 'rxjs';
import { createHttpParams } from '../utils/http-utils';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  http = inject(HttpClient);

  getUsers(
    page: number,
    size: number,
    username: string,
    defPort?: string,
  ): Observable<IGetUsersResponse> {
    defPort = defPort === 'ALL' ? undefined : defPort;

    const params = createHttpParams({
      page,
      size,
      username,
      defPort,
      airlineCode: 'PC',
    });

    return this.http.get<IGetUsersResponse>('users', { params });
  }
}
